export default httpClient => ({
    save: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/categorias-anuncios', dados, { headers });
        console.log(dados)
        return {
            data: response.data
        }
    },
    saveNegocio: async ({ dados, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/anuncios', dados, { headers });
        return {
            data: response.data
        }
    },
    saveGrupo: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/grupos-anuncios', dados, { headers });
        return {
            data: response.data
        }
    },
    update: async ({ dados, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/anuncios/' + dados.id, dados, { headers });
        return {
            data: response.data
        }
    },
    updateCat: async (dados, token) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json", "Content-Type": "multipart/form-data" }
        const response = await httpClient.post('/categorias-anuncios/' + dados.get('id'), dados, { headers });
        return {
            data: response.data
        }
    },
    getCatNegocio: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/categorias-anuncios', { headers });
        return {
            data: response.data
        }
    },
    getCatNegocioBydId: async ({ token, id }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/categorias-anuncios/' + id, { headers });
        return {
            data: response.data
        }
    },
    getGroupNegocio: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/grupos-anuncios', { headers });
        return {
            data: response.data
        }
    },
    gruposSite: async () => {
        const response = await httpClient.get('/grupos-site');
        return {
            data: response.data
        }
    },
    anuncioSite: async () => {
        const response = await httpClient.get('/anuncios-site');
        return {
            data: response.data
        }
    },
    getAll: async ({ token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/anuncios', { headers });
        return {
            data: response.data
        }
    },
    getById: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.get('/anuncios/' + id, { headers });
        return {
            data: response.data
        }
    },
    deleteGrupo: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/grupos-anuncios/' + id, { headers });
        return {
            data: response
        }
    },
    delete: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/categorias-anuncios/' + id, { headers });
        return {
            data: response
        }
    },
    deleteNegocio: async ({ id, token }) => {
        const headers = { "Authorization": "Bearer " + token, "Accept": "application/json" }
        const response = await httpClient.delete('/anuncios/' + id, { headers });
        return {
            data: response
        }
    },
    //-------SalvarImagem--------
    salvarImagem: async ({ token, formImagem }) => {
        let headers = { "Authorization": "Bearer " + token, "Content-Type": "multipart/form-data" }
        const response = httpClient.post('/imagens-anuncios', formImagem, { headers })
        return {
            data: response.data,
        }
    },
    deletarImagens: async ({ token, imagens }) => {
        const headers = {
            "Authorization": "Bearer " + token
        }
        const response = await httpClient.post('/excluir-imagens',
            {
                imagens
            }, { headers })
        return { data: response }
    },
    //-------Estado/Cidade-------
    estado: async () => {
        const response = await httpClient.get('/estados');
        return {
            data: response.data
        }
    },
    cidade: async (estado_id) => {
        const response = await httpClient.get('/cidades/' + estado_id,);
        return {
            data: response.data
        }
    },
    //-------Site-------
    getGPCat: async (grupo_id) => {
        const response = await httpClient.get('/categorias-por-grupo/' + grupo_id,);
        return {
            data: response.data
        }
    },
    cadastraNegocio: async (dados) => {
        const response = await httpClient.post('/anuncio', dados);
        return {
            data: response.data
        }
    },
    saveImagemSite: async (formImagem) => {
        const response = await httpClient.post('/imagem-anuncio', formImagem);
        return {
            data: response.data
        }
    },
    getAnuncioById: async ({ id }) => {
        const response = await httpClient.get('/anuncio/' + id);
        return {
            data: response.data
        }
    },
    getCatByGrupo: async () => {
        const response = await httpClient.get('/categorias-por-grupo/24');
        return {
            data: response.data
        }
    },
    getAnuncioByCat: async ({ id }) => {
        const response = await httpClient.get('/anuncios-por-categoria/' + id);
        return {
            data: response.data
        }
    },
});